/**
 * compactCount — the one social-counter format: exact below a thousand, then
 * truncated to one decimal with a suffix (4.9k → 5k → 10.1k → 100k → 1m).
 * Truncated, never rounded, so a game shows 5k only once it has earned the
 * five-thousandth — and the same value always renders the same everywhere,
 * unlike locale-dependent Intl compact notation.
 */
export function compactCount(value: number): string {
  const n = Math.max(0, Math.floor(value || 0));
  if (n < 1000) return String(n);
  const [scale, suffix] = n >= 1_000_000_000 ? [1_000_000_000, 'b'] : n >= 1_000_000 ? [1_000_000, 'm'] : [1000, 'k'];
  const scaled = Math.floor((n / scale) * 10) / 10;
  return `${Number.isInteger(scaled) ? scaled.toFixed(0) : scaled.toFixed(1)}${suffix}`;
}
